<template>
  <div>
    <div>
      <div class="is-flex is-align-items-center is-justify-content-flex-end">
        <div>
          <p class="sub_title"><b>DISTANCE</b></p>
          <p v-if="offer">{{ offer.distance }}</p>
        </div>
        <div class="horizontal_space"></div>
        <div>
          <p class="sub_title"><b>LOCATION</b></p>
          <p v-if="position_location">{{ position_location.description }}</p>
        </div>
        <div class="horizontal_space"></div>
        <div>
          <p class="sub_title"><b>POSITION</b></p>
          <link-entity :payload="position" :additional_data="{ resource_type: 'Position' }" class="suggested_position">
          </link-entity>
        </div>
        <div class="horizontal_space"></div>
        <div>
          <p class="sub_title"><b>COMPANY</b></p>
          <link-entity :payload="position.company"></link-entity>
        </div>
      </div>
      <div v-if="offer" class="is-flex is-align-items-center is-justify-content-flex-end">
        <a @click="openCVModal()" class="button is-info">
          Send CV
        </a>
        <div class="horizontal_space"></div>
        <offer-status :payload="offer"></offer-status>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import LinkEntity from '@/components/LinkEntity'
import OfferStatus from '@/components/OfferStatus'
export default {
  name: 'applicant-suggested-position',
  props: ['applicant', 'position'],
  data () {
    return {
      offer: undefined,
      position_location: undefined
    }
  },
  created () {
    this.getOffer()
    this.getPositionLocation()
  },
  methods: {
    openCVModal () {
      this.create({
        designator: 'send-cv-mode-selection-modal',
        component_name: 'SendCvModeSelectionModal',
        data: this.offer,
        modal_title: 'בחירת מצב שליחת קורות חיים',
        modal_width: 600,
        is_center_modal: true
      })
    },
    getOffer () {
      this.$network_utils.getOfferBy({ applicant_id: this.applicant.resource_id, position_id: this.position.id }).then(response => {
        this.offer = response[0]
      })
    },
    getPositionLocation () {
      this.$network_utils.getInheritanceLocation({ position_id: this.position.id, company_id: this.position.company.resource_id }).then(response => {
        this.position_location = response[0]
      })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    LinkEntity,
    OfferStatus
  }
}
</script>
<style scoped>
  .suggested_position {
    padding: 5px;
    border-radius: 15px;
    margin-left: 10px;
    margin-bottom: 10px;
  }
  .sub_title {
    text-align: left;
    font-size: 12px;
    line-height: 1px;
  }
</style>
